import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=31ad5625&"
import script from "./FormHeader.vue?vue&type=script&lang=js&"
export * from "./FormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ad5625')) {
      api.createRecord('31ad5625', component.options)
    } else {
      api.reload('31ad5625', component.options)
    }
    module.hot.accept("./FormHeader.vue?vue&type=template&id=31ad5625&", function () {
      api.rerender('31ad5625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/formcomponents/FormHeader.vue"
export default component.exports